import React, { ReactNode } from 'react';
import { IMytaverseFile, IVideoData } from '@interfaces/file';

export enum EventAssetType {
  IMAGE = 'IMAGE',
  VIDEO = 'VIDEO',
  AUDIO = 'AUDIO',
  OBJECT_3D = 'OBJECT_3D',
  RESOURCE = 'RESOURCE',
  HUB_MAP = 'HUB_MAP',
}

export interface IEventContext {
  isEventRun: boolean;
  setIsEventRun: React.Dispatch<React.SetStateAction<boolean>>;
  avatarConsentOpen: boolean;
  setAvatarConsentOpen: React.Dispatch<React.SetStateAction<boolean>>;
  launchArgs: string[] | null;
  setLaunchArgs: React.Dispatch<React.SetStateAction<string[] | null>>;
}

export type EventProviderProps = {
  children: ReactNode;
};

export interface IEventAsset {
  assetId: string;
  eventId: string;
  name: string;
  type: string;
  assetType?: string;
  section: string;
  description: string;
  gender?: string;
  videoDuration?: string;
  data: IMytaverseFile | IVideoData | null;
  timestamp: number;
  createdBy: string;
  tags?: string[];
}

export interface IEventAssets {
  assets: IEventAsset[];
  lastKey: IEventAsset | null;
}
